export const DELETE_ACCOUNT = '@@deleteAccount/deleteAccount'
export const DELETE_ACCOUNT_RESET = '@@deleteAccount/reset'
